import type { LabelHTMLAttributes, PropsWithChildren } from "react";

interface InputLabelProps extends PropsWithChildren, LabelHTMLAttributes<HTMLLabelElement> {
    value?: string;
}

export default function InputLabel({ value, children, className = "", ...rest }: InputLabelProps) {
    return (
        <label className={`block text-sm font-medium text-gray-300 ${className}`} {...rest}>
            {value ? <span>{value}</span> : <span>{children}</span>}
        </label>
    );
}
